module.exports = __webpack_public_path__ + "img/transport_RentalCarBooking.cf666f9.png";